import {onCLS, onINP, onLCP, onTTFB} from 'web-vitals/attribution';

import WebVitalsEvents from '../../../universal/events/webVitalsEvents';

const webVitalsBootstrapper = {
  init() {
    onINP(webVitalsBootstrapper.sendEvent, {reportAllChanges: true});
    onCLS(webVitalsBootstrapper.sendEvent, {reportAllChanges: true});
    onLCP(webVitalsBootstrapper.sendEvent);
    onTTFB(webVitalsBootstrapper.sendEvent);
  },

  sendEvent(params) {
    requestAnimationFrame(() => {
      setTimeout(() => {
        WebVitalsEvents.sendMetrics(params)
      }, 0);
    });
  }
};

export default webVitalsBootstrapper;
